class CartAjax extends HTMLElement {
  constructor() {
    super();
    this.symbolEnd = this.dataset.euroSymbolEnds === "true";
    this.templateElements();
    this.initProducts();
    this.initVariables();
    this.initItems();
    this.calcTotals();
    // this.clearTrash();
    // this.setElements();
  }

  changeQuantityCart (variant_id, qty, callback = false) {
    const data = {
      id: "" + variant_id,
      quantity: qty
    };
    fetch(window.Shopify.routes.root + 'cart/change.js',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(data)
      }).then(res => res.json()).then(data => {
      for (const item of data.items) {
        this.quantities[item.id] = item.quantity;
      }
    }).then(() => {
      if (callback)
        callback();
    });
  }

  addProductToCart (variant_id, qty, callback = false) {
    const data = {
      items: [
        {
          id: variant_id,
          quantity: qty
        }
      ]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js',
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify(data)
      }).then(res => res.json()).then(data => {
      for (const item of data.items) {
        this.quantities[item.id] = item.quantity;
      }
    }).then(() => {
      if (callback)
        callback();
    });
  }

  initItems() {
    const cartItems = this.querySelectorAll(".cart-ajax__item");
    const upsellItems = {};
    for (const item of cartItems) {
      this.setQuantitySelectors(item, item.dataset.id);
      const qty = item.querySelector("[data-qty]");
      const removeBtn = item.querySelector("[data-item-remove]");
      removeBtn.addEventListener("click", () => {
        const loadingState = item.querySelector("[data-item-loading]");
        removeBtn.classList.add("hidden");
        loadingState.classList.remove("hidden");
        this.changeQuantityCart(item.dataset.id, 0, () => {
          this.quantities[item.dataset.id] = 0;

          if (this.productsById[item.dataset.id] && !this.productsById[item.dataset.id].upsells && this.mainProduct.accepted !== false) {
            this.productsById[item.dataset.id].quantity = 0;
            this.setElement(this.productsById[item.dataset.id], true);
          } else {
            this.mainProduct.accepted = false;
            this.el.upsellWrapper.innerHTML = "";
            this.el.upsellTitle.classList.add("hidden");
            this.el.upsellWrapper.classList.add("hidden");
          }
          this.calcTotals();
          item.remove();
          this.checkUpsellWrapperEmpty();
        });

      })
    }
    for (const upsellProduct of this.mainProduct.upsells) {
      if (upsellProduct.accepted)
        continue;
      this.setElement(upsellProduct, true);
    }
    if (this.el.upsellWrapper.children.length > 0) {
      this.el.upsellTitle.classList.remove("hidden");
      this.el.upsellWrapper.classList.remove("hidden");
    } else {
      this.el.upsellTitle.classList.add("hidden");
      this.el.upsellWrapper.classList.add("hidden");
    }
  }

  displayEmptyCart() {
    this.el.emptyCart.classList.remove("hidden");
  }

  initProducts() {
    const cartItems = this.querySelectorAll(".cart-ajax__item");
    const upsellItems = {};
    for (const item of cartItems) {
      if (!item.dataset.upsell || item.dataset.upsell === "") {
        upsellItems[item.dataset.id] = {
          accepted: true,
          variant_id: item.dataset.id,
          quantity: parseInt(item.querySelector("[data-qty]").dataset.qty),
          price: parseInt(item.querySelector("[data-item-price]").dataset.itemPrice),
          compare_at_price: parseInt(item.querySelector("[data-item-compare]").dataset.itemCompare)
        }
      }
    }
    this.otherItems = [];
    this.productsById = {};
    this.mainProduct = {
      accepted: false,
      upsells: [],
      quantity: 0,
      id: 0,
      price: 0,
      compare_at_price: 0
    }
    for (const item of cartItems) {
      if (!item.dataset.upsell || item.dataset.upsell === "") {
        // continue;
        const other = {
          variant_id: item.dataset.id,
          title: item.querySelector(".cart-ajax__item__title").innerHTML,
          image: {
            url: item.querySelector(".cart-ajax__item__img").getAttribute("src"),
            width: item.querySelector(".cart-ajax__item__img").getAttribute("width"),
            height: item.querySelector(".cart-ajax__item__img").getAttribute("height"),
            defaultWidth: 130
          },
          price: parseInt(item.querySelector("[data-item-price]").dataset.itemPrice),
          compare_at_price: parseInt(item.querySelector("[data-item-compare]").dataset.itemCompare),
          quantity: parseInt(item.querySelector("[data-qty]").dataset.qty),
          minQuantity: parseInt(item.querySelector("[data-qty]").dataset.minQty),
          other: true
        };

        this.productsById[item.dataset.id] = other;
        this.otherItems.push(other);
      } else {

        if(this.mainProduct.id === 0){
          this.mainProduct = {
            variant_id: item.dataset.id,
            title: item.querySelector(".cart-ajax__item__title").innerHTML,
            image: {
              url: item.querySelector(".cart-ajax__item__img").getAttribute("src"),
              width: item.querySelector(".cart-ajax__item__img").getAttribute("width"),
              height: item.querySelector(".cart-ajax__item__img").getAttribute("height"),
              defaultWidth: 130
            },
            quantity: parseInt(item.querySelector("[data-qty]").dataset.qty),
            minQuantity: parseInt(item.querySelector("[data-qty]").dataset.minQty),
            price: parseInt(item.querySelector("[data-item-price]").dataset.itemPrice),
            compare_at_price: parseInt(item.querySelector("[data-item-compare]").dataset.itemCompare),
            upsells: []
          };

          this.productsById[item.dataset.id] = this.mainProduct;
        } else {
          const other = {
            variant_id: item.dataset.id,
            title: item.querySelector(".cart-ajax__item__title").innerHTML,
            image: {
              url: item.querySelector(".cart-ajax__item__img").getAttribute("src"),
              width: item.querySelector(".cart-ajax__item__img").getAttribute("width"),
              height: item.querySelector(".cart-ajax__item__img").getAttribute("height"),
              defaultWidth: 130
            },
            quantity: parseInt(item.querySelector("[data-qty]").dataset.qty),
            minQuantity: parseInt(item.querySelector("[data-qty]").dataset.minQty),
            price: parseInt(item.querySelector("[data-item-price]").dataset.itemPrice),
            compare_at_price: parseInt(item.querySelector("[data-item-compare]").dataset.itemCompare),
            other: true
          };

          this.productsById[item.dataset.id] = other;
          this.otherItems.push(other);
        }
        const upsellJson = JSON.parse(item.dataset.upsell);
        for (let upsellProduct of upsellJson) {
          const upsell = {
            id: upsellProduct.id,
            variant_id: upsellProduct["variant-id"],
            title: upsellProduct.title,
            description: upsellProduct.description,
            cart_description: upsellProduct.cart_description,
            image: {
              url: upsellProduct["cart-image-src"],
              width: upsellProduct["image-width"],
              height: upsellProduct["image-height"],
              defaultWidth: 130
            },
            price: upsellProduct.price,
            compare_at_price: upsellProduct.comparePrice,
            accepted: !!upsellItems[upsellProduct["variant-id"]],
            quantity: upsellItems[upsellProduct["variant-id"]] ? upsellItems[upsellProduct["variant-id"]].quantity : 1
          };

          if(!this.productsById[upsellProduct["variant-id"]]){
            this.mainProduct.upsells.push(upsell);
          }

          this.productsById[upsellProduct["variant-id"]] = upsell;
        }
      }
    }
    if (this.mainProduct.id === 0) {
      for (const upsellItem in upsellItems) {
        this.mainProduct.upsells.push(upsellItems[upsellItem]);
      }
    }
    if (!cartItems.length)
      this.displayEmptyCart();
  }

  openCurrentState() {
    this.setCloseButton();
    this.displayCart();
  }

  load(product, initiatorElement) {
    this.emptyUserCart();
    this.initVariables(product);
    this.clearTrash();
    this.setElements();
    this.setCloseButton(initiatorElement);
    this.displayCart();
  }

  emptyUserCart() {
    fetch(window.Shopify.routes.root + 'cart/clear.js', {method: "POST"});
  }

  templateElements() {
    const itemEl = this.querySelector(".cart-ajax__item[data-cart-item-template]");
    const upsellEl = this.querySelector(".cart-ajax__upsell[data-cart-upsell-template]");
    this.el = {
      item: itemEl.cloneNode(true),
      itemWrapper: this.querySelector("[data-item-wrapper]"),
      upsell: upsellEl.cloneNode(true),
      bodyLeft: this.querySelector(".cart-ajax__body__left"),
      upsellTitle: this.querySelector("[data-upsell-title]"),
      upsellWrapper: this.querySelector("[data-upsell-wrapper]"),
      subtotal: this.querySelector("[data-sub-total]"),
      savings: this.querySelector("[data-savings]"),
      total: this.querySelector("[data-total]"),
      paymentBtn: this.querySelector("[data-payment-button]"),
      shopifyHeader: document.querySelector("#shopify-section-header"),
      main: document.querySelector("#MainContent"),
      cartWrapper: document.querySelector(".cart-ajax"),
      closeButton: document.querySelector(".cart-ajax [data-cart-close]")
    }
    this.el.item.removeAttribute("data-cart-item-template");
    this.el.upsell.removeAttribute("data-cart-upsell-template");
    itemEl.remove();
    upsellEl.remove();
    this.el.emptyCart = this.querySelector("[data-empty-cart]");
  }

  clearTrash() {
    this.el.upsellWrapper.innerHTML = "";
    this.el.itemWrapper.innerHTML = "";
  }

  initVariables() {
    this.shopUrl = this.dataset.shopUrl;
    this.currency = this.dataset.currency;

    this.quantities = {
      [this.mainProduct.variant_id]: this.mainProduct.quantity ? this.mainProduct.quantity : 1
    }
    this.minQuantities = {
      [this.mainProduct.variant_id]: this.mainProduct.minQuantity ? this.mainProduct.minQuantity : 1
    }
    this.prices = {
      [this.mainProduct.variant_id]: {
        price: this.mainProduct.price,
        compare_at_price: this.mainProduct.compare_at_price
      }
    }

    this.total = {
      compare_at: 0,
      total: 0,
      savings: 0
    }

    for (let upsell of this.mainProduct.upsells) {
      this.quantities[upsell.variant_id] = upsell.quantity && upsell.accepted ? upsell.quantity : 0;
      this.minQuantities[upsell.variant_id] = 1;
      this.prices[upsell.variant_id] = {
        price: upsell.price,
        compare_at_price: upsell.compare_at_price
      }
    }

    for (let otherProduct of this.otherItems) {
      this.quantities[otherProduct.variant_id] = otherProduct.quantity ? otherProduct.quantity : 0;
      this.minQuantities[otherProduct.variant_id] = 1;
      this.prices[otherProduct.variant_id] = {
        price: otherProduct.price,
        compare_at_price: otherProduct.compare_at_price
      }
    }
  }

  displayCart() {
    this.el.cartWrapper.classList.remove("hidden");
    document.body.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
    for (let el of [this.el.shopifyHeader, this.el.main]) {
      if (el)
        el.classList.add("hidden");
    }
  }

  setCheckoutUrl() {
    let checkoutUrl = "/cart/";
    for (let [id, qty] of Object.entries(this.quantities)) {
      if (qty > 0)
        checkoutUrl += `${id}:${qty},`;
    }
    checkoutUrl = checkoutUrl.slice(0, -1);
    checkoutUrl += `?locale=${this.dataset.locale}`
    this.el.paymentBtn.setAttribute("href", checkoutUrl);
  }
  //
  // setElements() {
  //   if (this.mainProduct) {
  //     this.setElement(this.mainProduct, false);
  //
  //     for (let upsellInfo of this.mainProduct.upsells) {
  //       this.setElement(upsellInfo, !upsellInfo.accepted);
  //     }
  //   }
  //   if (this.el.upsellWrapper.children.length > 0) {
  //     this.el.upsellTitle.classList.remove("hidden");
  //     this.el.upsellWrapper.classList.remove("hidden");
  //   } else {
  //     this.el.upsellTitle.classList.add("hidden");
  //     this.el.upsellWrapper.classList.add("hidden");
  //   }
  // }

  setElement(product, upsell = true) {
    let item = upsell ? this.el.upsell.cloneNode(true) : this.el.item.cloneNode(true);
    item.setAttribute("data-id", product.variant_id);
    this.setItemImg(item, product.image);
    this.setItemInfo(item, product, upsell);
    if (!upsell) {
      this.el.itemWrapper.append(item);
      this.setQuantitySelectors(item, product.variant_id);
      const qty = item.querySelector("[data-qty]");
      this.changeQuantity(false, qty, product.variant_id);
      const removeBtn = item.querySelector("[data-item-remove]");
      removeBtn.addEventListener("click", () => {
        const loadingState = item.querySelector("[data-item-loading]");
        removeBtn.classList.add("hidden");
        loadingState.classList.remove("hidden");
        this.changeQuantityCart(product.variant_id, 0, () => {
          this.quantities[product.variant_id] = 0;
          product.quantity = 0;
          if (this.mainProduct.accepted !== false)
            this.setElement(product, true);
          this.calcTotals();
          item.remove();
          this.checkUpsellWrapperEmpty();
        });
      })
    } else {
      if(this.productsById[item.dataset.id].other){
        return;
      }
      this.el.upsellWrapper.append(item);
      const atc = item.querySelector("[data-atc]");
      atc.addEventListener("click", () => {
        this.addProductToCart(product.variant_id, 1, () => {
          this.calcTotals();
          item.remove();
          this.checkUpsellWrapperEmpty();
          this.setElement(product, false);
        });
      })
    }
    this.checkUpsellWrapperEmpty();
  }

  checkUpsellWrapperEmpty() {
    if (this.el.upsellWrapper.childElementCount === 0 && !this.el.upsellWrapper.classList.contains("hidden")) {
      this.el.upsellWrapper.classList.add("hidden");
      this.el.upsellTitle.classList.add("hidden");
    } else if (this.el.upsellWrapper.childElementCount > 0 && this.el.upsellWrapper.classList.contains("hidden")) {
      this.el.upsellWrapper.classList.remove("hidden");
      this.el.upsellTitle.classList.remove("hidden");
    } else if (this.el.upsellWrapper.childElementCount === 0 && this.el.itemWrapper.childElementCount === 0) {
      this.displayEmptyCart();
    }
  }

  setQuantitySelectors(item, id) {
    const removeBtn = item.querySelector("[data-remove]");
    const addBtn = item.querySelector("[data-add]");
    const qty = item.querySelector("[data-qty]");

    for (let btn of [removeBtn, addBtn]) {
      btn.addEventListener("click", this.changeQuantity.bind(this, btn.dataset.hasOwnProperty("add"), qty, id, item));
    }
  }

  calcTotals() {
    let compare_at = 0;
    let price = 0;
    let savings = 0;
    for (let [id, qty] of Object.entries(this.quantities)) {
      if (qty > 0) {
        compare_at += this.prices[id].compare_at_price * qty;
        price += this.prices[id].price * qty;
        savings = (compare_at - price);
      }
    }

    if (this.symbolEnd) {
      this.el.subtotal.innerHTML = `${compare_at / 100} ${this.currency} `;
      this.el.total.innerHTML = `${price / 100} ${this.currency}`;
      this.el.savings.innerHTML = `${savings / 100} ${this.currency}`;
    } else {
      this.el.subtotal.innerHTML = `${this.currency} ${compare_at / 100}`;
      this.el.total.innerHTML = `${this.currency} ${price / 100}`;
      this.el.savings.innerHTML = `${this.currency} ${savings / 100}`;
    }
  }

  changeQuantity(add, qty, variant_id, item) {
    let removeBtn;
    let loadingState;
    if (item) {
      removeBtn = item.querySelector("[data-item-remove]");
      loadingState = item.querySelector("[data-item-loading]");
      removeBtn.classList.add("hidden");
      loadingState.classList.remove("hidden");
    }

    let qtyInt = parseInt(qty.innerHTML);
    if (add) {
      ++qtyInt;
    } else if (!add && qtyInt > this.minQuantities[variant_id]) {
      --qtyInt;
    }
    this.changeQuantityCart(variant_id, qtyInt, () => {
      qty.innerHTML = this.quantities[variant_id];
      if (removeBtn) {
        removeBtn.classList.remove("hidden");
        loadingState.classList.add("hidden");
      }
      this.calcTotals();
    });
  }

  setItemImg(item, img) {
    const imgUrl = img.url.split("\n").join("");
    let srcSet = "";
    for (let size of [130, 260, 390]) {
      if (size >= img.width)
        srcSet += `${imgUrl}&width=${size} ${size}w, `
    }
    srcSet += `${imgUrl} ${img.width}w`

    const itemImg = item.querySelector("img");
    itemImg.setAttribute("srcset", srcSet);
    itemImg.setAttribute("src", `${imgUrl}&width=${img.defaultWidth}`);
    itemImg.setAttribute("width", img.width);
    itemImg.setAttribute("height", img.height);
  }

  setItemInfo(item, info, upsell = false) {
    const selectorType = upsell ? ".cart-ajax__upsell" : ".cart-ajax__item";
    item.querySelector(`${selectorType}__title`).innerHTML = info.title;

    if (this.symbolEnd) {
      item.querySelector(`${selectorType}__compare-price`).innerHTML = info.compare_at_price / 100 + ` ${this.currency}`;
      item.querySelector(`${selectorType}__price`).innerHTML = info.price / 100 + ` ${this.currency}`;
      item.querySelector(`[data-item-savings]`).innerHTML = (info.compare_at_price - info.price) / 100 + ` ${this.currency}`;
    } else {
      item.querySelector(`${selectorType}__compare-price`).innerHTML = `${this.currency} ` + info.compare_at_price / 100;
      item.querySelector(`${selectorType}__price`).innerHTML = `${this.currency} ` + info.price / 100;
      item.querySelector(`[data-item-savings]`).innerHTML = `${this.currency} ` + (info.compare_at_price - info.price) / 100 ;
    }

    if (upsell)
      item.querySelector(`${selectorType}__description`).innerHTML = info.cart_description;
    else {
      item.querySelector(`[data-qty]`).innerHTML = info.quantity ? info.quantity + 1 : 1;
    }
  }
}

customElements.define('cart-ajax', CartAjax);
